import { render, staticRenderFns } from "./ButtonERC20.vue?vue&type=template&id=37ded794"
import script from "./ButtonERC20.vue?vue&type=script&lang=js"
export * from "./ButtonERC20.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports